/* =========================================================
   MV — Card Swipe
   Native horizontal scroll-snap + iOS vertical handoff
   - Mobile only
   - Never preventDefault on touchmove
   - Vertical gesture yields back to page scroll
   - Tap on image navigates to product
   - Swipe does not trigger accidental navigation
   - No dots / no progress bar
   ========================================================= */

(() => {
  const SWIPE_SEL = "[data-mv-swipe]";
  const TRACK_SEL = ".mv-card-swipe__track";
  const MOBILE_MQ = "(max-width: 749px)";

  const TAP_SLOP = 8;
  const LOCK_SLOP = 10;
  const V_BIAS = 1.15;

  const mql = window.matchMedia(MOBILE_MQ);

  function isMobile() {
    return mql.matches;
  }

  function initOne(root) {
    if (!root || root.dataset.mvSwipeReady === "true") return;

    const track = root.querySelector(TRACK_SEL);
    if (!track) return;

    const slides = Array.from(track.children);
    const url = root.getAttribute("data-url");

    if (!slides.length) return;

    root.dataset.mvSwipeReady = "true";

    let startX = 0;
    let startY = 0;
    let moved = false;
    let decided = false;
    let verticalIntent = false;
    let horizontalIntent = false;
    let suppressNextClick = false;

    function resetGesture() {
      startX = 0;
      startY = 0;
      moved = false;
      decided = false;
      verticalIntent = false;
      horizontalIntent = false;
      suppressNextClick = false;
      track.style.pointerEvents = "";
    }

    function temporarilyYieldToPageScroll() {
      track.style.pointerEvents = "none";

      window.setTimeout(() => {
        track.style.pointerEvents = "";
      }, 80);
    }

    track.addEventListener(
      "touchstart",
      (event) => {
        if (!isMobile()) return;

        const touch = event.touches && event.touches[0];
        if (!touch) return;

        resetGesture();

        startX = touch.clientX;
        startY = touch.clientY;
      },
      { passive: true }
    );

    track.addEventListener(
      "touchmove",
      (event) => {
        if (!isMobile()) return;

        const touch = event.touches && event.touches[0];
        if (!touch) return;

        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;

        const adx = Math.abs(dx);
        const ady = Math.abs(dy);

        if (adx > TAP_SLOP || ady > TAP_SLOP) {
          moved = true;
        }

        if (!decided && (adx > LOCK_SLOP || ady > LOCK_SLOP)) {
          decided = true;

          if (ady > adx * V_BIAS) {
            verticalIntent = true;
            horizontalIntent = false;
            temporarilyYieldToPageScroll();
          } else {
            verticalIntent = false;
            horizontalIntent = true;
          }
        }

        if (horizontalIntent && moved) {
          suppressNextClick = true;
        }
      },
      { passive: true }
    );

    track.addEventListener(
      "touchend",
      () => {
        if (!isMobile()) return;

        track.style.pointerEvents = "";

        if (url && !moved && !horizontalIntent && !verticalIntent) {
          window.location.href = url;
          return;
        }

        if (moved) {
          suppressNextClick = true;

          window.setTimeout(() => {
            suppressNextClick = false;
          }, 250);
        }
      },
      { passive: true }
    );

    track.addEventListener(
      "touchcancel",
      () => {
        track.style.pointerEvents = "";
      },
      { passive: true }
    );

    track.addEventListener(
      "click",
      (event) => {
        if (!isMobile()) return;

        if (moved || suppressNextClick) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    function handleBreakpointChange() {
      if (!isMobile()) {
        track.style.pointerEvents = "";
      }
    }

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handleBreakpointChange);
    } else if (typeof mql.addListener === "function") {
      mql.addListener(handleBreakpointChange);
    }
  }

  function initAll() {
    document.querySelectorAll(SWIPE_SEL).forEach(initOne);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);

  if (typeof mql.addEventListener === "function") {
    mql.addEventListener("change", initAll);
  } else if (typeof mql.addListener === "function") {
    mql.addListener(initAll);
  }
})();